import React from "react";

export const LightboxButton = ({
	onClick,
	buttonText = undefined,
	icon,
	title = undefined,
}) => {
	return (
		<button
			onClick={onClick}
			className="product-lightbox__button"
			title={title}
		>
			{icon}
			{buttonText ? <p>{buttonText}</p> : null}
		</button>
	);
};
